import React, { useState } from "react";
import "./Track.css";

const Track = () => {
  // State for handling form data and validation error
  const [awbId, setAwbId] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  // Handle input change
  const handleInputChange = (e) => {
    setAwbId(e.target.value);
    setErrorMessage(""); // Clear the error when the user starts typing
  };

  // Handle form submit
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!awbId.trim()) {
      setErrorMessage("Please Enter AWB/Tracking ID");
      return;
    }

    // If form is valid, you can submit or perform any actions here
    alert("Form submitted successfully!");
    setAwbId(""); // Clear the input after submission
  };

  return (
    <>
      <div
        className="banner-container"
        style={{ backgroundColor: "black", padding: "50px 0" }}
      >
        <div className="container ">
          <div className="row align-items-center">
            {/* Left Side - Form */}
            <div className="col-12 col-md-6 text-white">
              <h2 className="fw-bold text-center text-md-start">
                Track Your Order
              </h2>
              <form className="mt-4 form-container" onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="awbId" className="form-label">
                    Enter AWB/Tracking ID
                  </label>
                
                 
                  <input
                    type="text"
                    className="form-control"
                    id="awbId"
                    placeholder="Enter Tracking ID"
                    value={awbId}
                    onChange={handleInputChange}
                  />
                  {/* Show error message if validation fails */}
                  {errorMessage && (
                    <div className="text-danger mt-2">{errorMessage}</div>
                  )}
                </div>
                <hr style={{color: "red"}}/>
                <div className="text-center text-md-start">
                  <button type="submit" className="btn btn-primary mt-3">
                    Track Now
                  </button>
                </div>
                {/* Display additional message */}
                <p className="text-center text-md-start mt-3 text-black">
                  Can't Find Your Tracking Details? <br />
                  We sent your AWB/tracking ID to you via SMS upon booking
                  confirmation.
                </p>
              </form>
            </div>

            {/* Right Side - Image */}
            <div className="col-12 col-md-6 text-center">
              <img
                src="https://www.valmo.in/static-assets/valmo-web/truck_image_mobile.png?w=1080"
                alt="img"
                className="img-fluid rounded"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Track;
